import React, { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Error } from '../../components'
import { triggerErrorPageLoadEvent } from '../../utils/analytics'
import { getCallbackError } from '../../utils/errors'
import { newRelicTriggerErrorEvent } from '../../utils/newrelic'

export default function BrowseCallbackError() {
  const [searchParams] = useSearchParams()
  const error = getCallbackError(searchParams)

  useEffect(() => {
    newRelicTriggerErrorEvent('browse-callback-error', error.code)
    triggerErrorPageLoadEvent(error.code)
  }, [])

  return (
    <div data-testid="browse-callback-error">
      <Error {...error} />
    </div>
  )
}
